import React from 'react';
import { Users, Search, ArrowRight, ShieldCheck } from 'lucide-react';
export const FindSupplier = () => {
  return <div className="bg-gray50 min-h-screen" data-id="element-270">
      {/* Hero Section */}
      <div className="bg-white border-b border-gray200 py-16 lg:py-24" data-id="element-271">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-272">
          <div className="w-16 h-16 bg-gray50 border border-gray200 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-273">
            <Users className="w-8 h-8 text-charcoal" data-id="element-274" />
          </div>
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-ink mb-6 leading-tight" data-id="element-275">
            Need Custom Uniforms for Your Team or Organization?
          </h1>
          <p className="text-lg text-gray-600 leading-relaxed max-w-2xl mx-auto" data-id="element-276">
            Tell us what you need and we can help connect you with an approved
            supplier who can manage your order.
          </p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 py-12 lg:py-16" data-id="element-277">
        {/* Important Notice */}
        <div className="bg-ink text-white p-6 rounded-xl shadow-lg mb-10 flex gap-4 items-start" data-id="element-278">
          <ShieldCheck className="w-6 h-6 text-brandRed shrink-0 mt-1" data-id="element-279" />
          <div data-id="element-280">
            <h3 className="font-bold text-lg mb-2" data-id="element-281">Important Notice</h3>
            <p className="text-gray-300 text-sm leading-relaxed" data-id="element-282">
              CustomUniformSupplier.com is a wholesale manufacturing platform.
              We do not sell directly to retail customers or individual teams.
              By submitting this form, you are requesting to be connected with
              an independent, approved dealer in our network who can provide
              pricing, design assistance, and order management for your team.
            </p>
          </div>
        </div>

        {/* Form */}
        <div className="bg-white rounded-xl border border-gray200 shadow-sm overflow-hidden" data-id="element-283">
          <div className="bg-gray50 border-b border-gray200 p-6 md:p-8 flex items-center gap-3" data-id="element-284">
            <Search className="w-5 h-5 text-gray-500" data-id="element-285" />
            <h2 className="text-xl font-heading font-bold text-ink" data-id="element-286">
              Find a Supplier Request
            </h2>
          </div>

          <form className="p-6 md:p-8 flex flex-col gap-6" onSubmit={e => e.preventDefault()} data-id="element-287">
            {/* Contact Info */}
            <div className="grid md:grid-cols-2 gap-4" data-id="element-288">
              <div className="flex flex-col gap-1.5" data-id="element-289">
                <label className="text-sm font-semibold text-charcoal" data-id="element-290">
                  Your Name *
                </label>
                <input type="text" className="w-full px-4 py-2.5 rounded-sm border border-gray200 focus:border-brandRed focus:ring-1 focus:ring-brandRed outline-none transition-all" required data-id="element-291" />
              </div>
              <div className="flex flex-col gap-1.5" data-id="element-292">
                <label className="text-sm font-semibold text-charcoal" data-id="element-293">
                  Organization / Team Name *
                </label>
                <input type="text" className="w-full px-4 py-2.5 rounded-sm border border-gray200 focus:border-brandRed focus:ring-1 focus:ring-brandRed outline-none transition-all" required data-id="element-294" />
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-4" data-id="element-295">
              <div className="flex flex-col gap-1.5" data-id="element-296">
                <label className="text-sm font-semibold text-charcoal" data-id="element-297">
                  Email Address *
                </label>
                <input type="email" className="w-full px-4 py-2.5 rounded-sm border border-gray200 focus:border-brandRed focus:ring-1 focus:ring-brandRed outline-none transition-all" required data-id="element-298" />
              </div>
              <div className="flex flex-col gap-1.5" data-id="element-299">
                <label className="text-sm font-semibold text-charcoal" data-id="element-300">
                  Phone Number *
                </label>
                <input type="tel" className="w-full px-4 py-2.5 rounded-sm border border-gray200 focus:border-brandRed focus:ring-1 focus:ring-brandRed outline-none transition-all" required data-id="element-301" />
              </div>
            </div>

            <div className="flex flex-col gap-1.5" data-id="element-302">
              <label className="text-sm font-semibold text-charcoal" data-id="element-303">
                Location (City, State) *
              </label>
              <input type="text" placeholder="e.g., Dallas, TX" className="w-full px-4 py-2.5 rounded-sm border border-gray200 focus:border-brandRed focus:ring-1 focus:ring-brandRed outline-none transition-all" required data-id="element-304" />
              <span className="text-xs text-gray-500" data-id="element-305">
                Helps us find a supplier near you.
              </span>
            </div>

            <hr className="border-gray100 my-2" data-id="element-306" />

            {/* Project Details */}
            <div className="grid md:grid-cols-2 gap-4" data-id="element-307">
              <div className="flex flex-col gap-1.5" data-id="element-308">
                <label className="text-sm font-semibold text-charcoal" data-id="element-309">
                  Sport / Category *
                </label>
                <select className="w-full px-4 py-2.5 rounded-sm border border-gray200 focus:border-brandRed focus:ring-1 focus:ring-brandRed outline-none transition-all bg-white" required data-id="element-310">
                  <option value="" data-id="element-311">Select sport...</option>
                  <option value="baseball" data-id="element-312">Baseball</option>
                  <option value="football" data-id="element-313">Football</option>
                  <option value="basketball" data-id="element-314">Basketball</option>
                  <option value="softball" data-id="element-315">Softball</option>
                  <option value="track" data-id="element-316">Track and Field</option>
                  <option value="soccer" data-id="element-317">Soccer</option>
                  <option value="volleyball" data-id="element-318">Volleyball</option>
                  <option value="other" data-id="element-319">Other</option>
                </select>
              </div>
              <div className="flex flex-col gap-1.5" data-id="element-320">
                <label className="text-sm font-semibold text-charcoal" data-id="element-321">
                  Estimated Quantity *
                </label>
                <select className="w-full px-4 py-2.5 rounded-sm border border-gray200 focus:border-brandRed focus:ring-1 focus:ring-brandRed outline-none transition-all bg-white" required data-id="element-322">
                  <option value="" data-id="element-323">Select quantity...</option>
                  <option value="1-15" data-id="element-324">1 - 15 items</option>
                  <option value="16-50" data-id="element-325">16 - 50 items</option>
                  <option value="51-100" data-id="element-326">51 - 100 items</option>
                  <option value="100+" data-id="element-327">100+ items</option>
                </select>
              </div>
            </div>

            <div className="flex flex-col gap-1.5" data-id="element-328">
              <label className="text-sm font-semibold text-charcoal" data-id="element-329">
                Timeline / Need By Date
              </label>
              <input type="text" placeholder="e.g., Start of season in August" className="w-full px-4 py-2.5 rounded-sm border border-gray200 focus:border-brandRed focus:ring-1 focus:ring-brandRed outline-none transition-all" data-id="element-330" />
            </div>

            <div className="flex flex-col gap-1.5" data-id="element-331">
              <label className="text-sm font-semibold text-charcoal" data-id="element-332">
                What are you looking for? *
              </label>
              <textarea rows={4} className="w-full px-4 py-2.5 rounded-sm border border-gray200 focus:border-brandRed focus:ring-1 focus:ring-brandRed outline-none transition-all resize-none" placeholder="Please describe the uniforms or apparel you need (e.g., 20 sublimated baseball jerseys and pants, need design help...)" required data-id="element-333"></textarea>
            </div>

            <button type="submit" className="w-full bg-charcoal hover:bg-ink text-white font-bold py-4 px-6 rounded-sm text-center transition-colors shadow-lg mt-4 text-lg flex items-center justify-center gap-2" data-id="element-334">
              Submit Request <ArrowRight className="w-5 h-5" data-id="element-335" />
            </button>
          </form>
        </div>
      </div>
    </div>;
};